import router from './router'
import store from './store'

import NProgress from "nprogress"; // 导入 nprogress模块
import "nprogress/nprogress.css"; // 导入样式，否则看不到效果
NProgress.configure({ showSpinner: false }); // 显示右上角螺旋加载提示

router.beforeEach(async (to, from, next) => {
    NProgress.start();
    if ((store.state.user == null || store.state.user == undefined) && to.path != '/login') {
        //没登录去login页面
        next('/login');
        NProgress.done(); //完成进度条
    }
    else {
        //登录了
        if (to.path == '/') {
            next('/home');
            NProgress.done(); //完成进度条
        }
        next();
    }
})
router.afterEach(() => {
    NProgress.done(); //完成进度条
});


// WEBPACK FOOTER //
// ./src/permission.js